export const modalConfirm = 'MODAL_CONFIRM';
export const modalClose = 'MODAL_CLOSE';
